import React from 'react';
import classNames from 'classnames';

import styles from './FoodDiets.module.scss';
import { useTranslation } from 'features/translator';

interface IFoodDiets {
  diets: string[];
  size?: 'small' | 'large';
  hasUnsuitables?: boolean;
}

const FoodDiets: React.FunctionComponent<IFoodDiets> = ({ diets, size = 'small', hasUnsuitables = false }) => {
  const translation = useTranslation();
  const filteredDiets = diets.filter((diet) => diet !== 'Ilmastovalinta');

  if (!filteredDiets.length) {
    return null;
  }

  const componentClass = classNames(styles.component, styles[size], {
    [styles.hasUnsuitables]: hasUnsuitables,
    [styles.allowWrap]: filteredDiets.length > 4,
  });

  return (
    <div className={componentClass}>
      {filteredDiets.map((diet) => {
        const dietLabel = translation.label(diet).replace('pyydä', `<span>${translation.get('foods', 'request')}</span>`);
        const formattedLabel = diet === 'KELA' ? dietLabel.replace(/(.{2})(?=.)/g, '$1<br>') : dietLabel;

        const dietClass = classNames(styles.diet, { [styles.kela]: diet === 'KELA' });

        return <div key={diet} className={dietClass} dangerouslySetInnerHTML={{ __html: formattedLabel }} />;
      })}
    </div>
  );
};

export default FoodDiets;
